import { createError, defineNuxtRouteMiddleware } from '#imports'

import { useBuybackEnabled } from '../composables/useBuybackEnabled/useBuybackEnabled'

export default defineNuxtRouteMiddleware(() => {
  const { isRegularTradeInEnabled } = useBuybackEnabled()

  if (!isRegularTradeInEnabled) {
    throw createError({
      statusCode: 404,
      statusMessage: 'Trade-in is not enabled for this market',
      fatal: true,
    })
  }
})
